.main {
  display: flex;
  flex-direction: row;
  flex: 1;
}

.toolbar {
  background: var(--accent);
  padding: 4px;
  display: flex;
  gap: 4px;
  justify-content: end;
}
